<form class="evidence-edit-form" [formGroup]="evidenceForm" novalidate>

  <div class="iaud-value-container evidence-edit-form--file">
    <label>Upload evidence file (e.g. PDF, JPG or other)</label>
    <div ngfDrop ngfSelect *ngIf="!file && !evidence.fileName" [(file)]="file" ([validDrag])="validDrag"
      ([invalidDrag])="invalidDrag" [ngClass]="{'myHoverClass': validDrag, 'myAntiHoverClass': validDrag}"
      class="my-drop-zone">
      Drag and drop image or <span class="evidence-edit-form--browse">browse</span>
    </div>
    <div *ngIf="file" class="evidence-edit-form--hasfile">
      <p class="evidence-edit-form--hasfile--filename">{{file.name}}</p>
      <p class="evidence-edit-form--hasfile--filesize">{{ file.size/1024 | number: '1.0-0' }} kB</p>
      <button class="evidence-edit-form--hasfile--deletebtn" mat-icon-button color="warn" (click)="clearfile()">
        <mat-icon>delete</mat-icon>
      </button>
      <label class="evidence-edit-form--hasfile--uploader">uploaded by {{evidence?.uploadedBy}}</label>
    </div>
    <div *ngIf="evidence?.fileName && !file" class="evidence-edit-form--hasfile">
        <p class="evidence-edit-form--hasfile--filename">{{evidence.fileName}}</p>
        <p class="evidence-edit-form--hasfile--filesize">{{ evidence.fileSize/1024 | number: '1.0-0' }} kB</p>
        <button class="evidence-edit-form--hasfile--deletebtn" mat-icon-button color="warn" (click)="clearfile()">
          <mat-icon>delete</mat-icon>
        </button>
        <label class="evidence-edit-form--hasfile--uploader">uploaded by {{evidence?.uploadedBy}}</label>
      </div>
    </div>

  <mat-form-field class="evidence-edit-form--description">
    <textarea matInput #description rows="3" placeholder="Description" formControlName="description"></textarea>
    <mat-hint align="end">{{ description.value.length || 0 }} / 2000</mat-hint>
    <mat-hint class="evidence-edit-form--hasfile--describer">Described by {{evidence?.describedBy}}</mat-hint>
  </mat-form-field>

</form>